import { POINTS_CIRCLE_LAYER } from './constants';
import { handleMapClick, handleSelectPoint } from './MapMarkers';

/**
 * Create and attach map click event handler
 */
export const createMapClickHandler = (
  map, 
  locations, 
  currentMode, 
  setupSubmode, 
  setLocations
) => {
  return (e) => {
    // Don't handle clicks if map isn't loaded
    if (!map || !map.loaded()) return;
    
    // Call map click handler from MapMarkers with required parameters
    handleMapClick(e, {
      currentMode,
      setupSubmode,
      locations,
      setLocations
    });
  };
};

/**
 * Create and attach point click event handler
 */
export const createPointClickHandler = (
  map, 
  locations, 
  startId, 
  currentMode, 
  setStartId, 
  onMapPointSelect
) => {
  // Log when creating click handler

  if ((currentMode === 'Custom Path' || currentMode === 'Connection Mode') && !onMapPointSelect) {
    console.warn(`Creating point click handler for ${currentMode} without callback!`);
  }
  
  return (e) => {
    console.log(`Point click event in ${currentMode} mode`);
    
    // Don't handle clicks if map isn't loaded
    if (!map || !map.loaded()) {
      console.log('Map not loaded, ignoring click');
      return;
    }

    // Get features at click point
    const features = map.queryRenderedFeatures(e.point);
    console.log('Features found at click:', features);

    // If clicked on a point
    if (features.length > 0) {
      // Get point ID from feature properties
      const pointId = features[0].properties.id;
      console.log('Point ID from feature:', pointId);

      // Perform detailed callback validation
      if (onMapPointSelect) {
        const callbackType = typeof onMapPointSelect;

        if (callbackType !== 'function') {
          console.error(`Invalid callback type: expected function, got ${callbackType}`);
          return;
        }
      } else {
        console.warn(`Point select callback is ${onMapPointSelect}`);
        
        // Extra callback verification for debugging
        if (currentMode === 'Custom Path' || currentMode === 'Connection Mode') {
          console.error(`No point selection callback in ${currentMode} mode`);
          return; // Early return if no callback in these modes
        }
      }
      
      // Call point selection handler with detailed parameters
      handleSelectPoint({
        map,
        pointId,
        locations,
        startId,
        currentMode,
        setStartId,
        onMapPointSelect
      });
    }
  };
}; 